<template>
	<section id="create-question">
		<Notification corner="bottom-right" :closed="true" />
		<form :class="{ readOnly: this.$route.name === 'questoesDetails' }">
			<container textButton="voltar" :pathName="'/questoes'" :pathIcone="true">
				<load-content v-if="!isLoaded" />
				<div v-if="isLoaded">
					<div v-if="this.$route.name !== 'questoesDetails'" class="orientacoes">
						<b>Orientações:</b>
						<p>
							Para realizar o cadastro de questões, é necessário seguir os passos abaixo descritos:<br /><br />
							<ol>
								<li><b>1</b>. Selecione o objeto vinculado à questão através dos filtro abaixo e preencha os dados da questão.</li>
								<li><b>2</b>. Selecione o tipo de questão</li>
								<li><b>3</b>. Preencha o enunciado da questão e todas as alternativas. Você pode adicionar e/ou remover alternativas através dos botões no editor</li>
								<li><b>4</b>. Selecione a alternativa correta. A alternativa selecionada estará marcada em amarelo</li>
								<li><b>5</b>. Preencha os textos de Feedback positivo e Feedback negativo</li>
								<li><b>6</b>. Ao finalizar o preenchimento, clique no botão "PUBLICAR" ao final da página</li>
							</ol>
						</p>
					</div>
					<div class="vinculo">
						<b>Vincular ao objeto</b>
						<div class="bonding-grid">
							<Multiselect placeholder="Informe a curadoria" v-model="questao.curadoria" @select="clearSubs" track-by="id" label="nome" :options="curadoriasList" class="select curadoria" />
							<Multiselect placeholder="Informe a subcuradoria" v-model="questao.subCuradoria" @select="clearEixos" track-by="id" label="nome" :options="subCuradoriasList" class="select subcuradoria" />
							<Multiselect placeholder="Informe o eixo" v-model="questao.eixo" @select="limparTema" @input="() => loadThemes(questao.eixo, questao.tipoObjeto)" track-by="id" label="nome" :options="eixosList" class="select eixo" />
							<Multiselect placeholder="Informe o tipo de objeto" v-model="questao.tipoObjeto" @select="limparTema" @input="() => loadThemes(questao.eixo, questao.tipoObjeto)" track-by="id" label="nome" :options="tiposObjeto" class="select tipoObjeto" />
							<Multiselect placeholder="Informe o objeto" v-model="questao.tema" track-by="id" @input="carregarTipo" label="titulo" :options="temas" class="select tema" />
							<Multiselect placeholder="Informe o nível de dificuldade" v-model="questao.nivelDificuldade" track-by="id" label="descricao" :options="niveisDificuldade" class="select nivel" />
							<Multiselect placeholder="Informe o tipo de questão" v-model="questao.tipoQuestao" track-by="id" label="descricao" :options="tiposQuestao" class="select tipo" />
							<div class="actions" v-if="this.$route.name !== 'questoesDetails'">
								<a href="javascript:void(0)" @click="clearBonding" class="btn limpar">Limpar</a>
							</div>
						</div>
					</div>
				</div>
			</container>
			<div class="editor-container" v-if="isLoaded">
				<div class="editor-container-header">
					Questão
					<span class="codigo" v-if="questao.codigo && !getCode(Object.assign(questao, objeto)).error">{{ getCode(Object.assign(questao, objeto)) }}</span>
					<span class="codigo error" v-if="questao.codigo && getCode(Object.assign(questao, objeto)).error">{{ getCode(Object.assign(questao, objeto)).msg }}</span>
					<div class="historico" v-if="this.$route.params.id">
						<button type="button" :disabled="!questao.historico" @click="historyId = questao.id">
							<i class="fas fa-history"></i>
							HISTÓRICO
						</button>
					</div>
				</div>
				<div class="editor-container-body">
					<div class="editor-question-data">
						<span class="dt-insert" v-if="this.$route.name !== 'questoesCreate'">
							<b>Data de cadastro: </b><br />
							{{ questao.dtInsert.replace(' ', ' ás ') }}
						</span>
						<span class="dt-update" v-if="this.$route.name !== 'questoesCreate'">
							<b>Data de atualização: </b><br />
							{{ questao.dtUpdate.replace(' ', ' ás ') }}
						</span>
						<span class="status">
							<b>Status da produção: </b><br />
							<Multiselect placeholder="Informe o status de produção" v-model="questao.status" track-by="status" label="nome" :options="statusList" class="select status" />
						</span>
					</div>
						<MathQuestionEditor id="1" :show="this.questao.enunciado" :info="getInfoComponent" title="Enunciado" :route="this.$route.name" />
					<div class="editor-alternatives">
						<div class="editor-alternatives-tabs-menu">
							<a class="editor-alternatives-tabs-button" @click="changeTab(index)" href="javascript:void(0)" v-for="(value, index) in questao.alternativas" :key="index" :data-tab-index="index">Alternativa {{ index + 1 }}</a>
							<a href="javascript:void(0)" class="btn editor-alternatives-tabs-add" @click="addAlternative()">
								<span class="fas fa-plus"></span>
							</a>
						</div>
						<div class="editor-alternatives-tabs-content">
							<div class="editor editor-alternatives-tab-editor" v-for="(value, index) in questao.alternativas" :key="index" :data-tab-index="index">
								<MathQuestionEditor id="2" :index="index" delete :removeAlt="() => removeAlternative(index)" :show="questao.alternativas[index].valor" :info="getInfoComponent" :title="`Texto da alternativa ${index + 1}`" :route="value.rota" />
							</div>
							<div class="editor-alternatives-select">
								Marque a alternativa correta:
								<a class="editor-alternatives-select-option" :class="{ active: questao.alternativas[index].correta }" href="javascript:void(0)" @click="selectAlternative(index)" v-for="(value, index) in questao.alternativas" :key="index" :data-alternative-index="index">{{ index + 1 }}</a>
							</div>
						</div>
					</div>
					<div class="editor-feedback">
						<MathQuestionEditor id="3" :show="this.questao.feedbackPositivo" :info="getInfoComponent" title="Texto de feedback positivo" :route="this.$route.name" />
						<MathQuestionEditor id="4" :show="this.questao.feedbackNegativo" :info="getInfoComponent" title="Texto de feedback negativo" :route="this.$route.name" />
					</div>
				</div>
				<div class="box-warning" v-if="questao.status && questao.status.status === 3">
					<b>Atenção:</b> Objetos com o status "Preenchimento pendente" serão automaticamente alterados para o status "Pendente" ao realizar uma edição.
				</div>
				<div class="editor-actions">
					<router-link :to="{ name: 'questoesList' }" class="btn voltar-button">
						<span><i class="fas fa-arrow-left"></i> Voltar</span>
					</router-link>
					<a v-if="this.$route.name !== 'questoesDetails'" href="javascript:void(0)" @click="submitForm" :class="{ btn: true, 'editor-submit': true, sending }">
						<span>
							Publicar
							<span v-if="sending" class="download-status downloading"></span>
						</span>
					</a>
				</div>
			</div>
			<new-modal v-if="historyId" @close="historyId = undefined" id="historico-modal">
					<div class="header" slot="header">
						<span>
							<i class="fas fa-history"></i>
							HISTÓRICO
						</span>
					</div>
					<div slot="body">
						<historico :question="historyId"></historico>
					</div>
			</new-modal>
		</form>
	</section>
</template>

<script>
import { questoes } from '@/services/questoes'
import { curadoria } from '@/services/curadoria'
import { objetos } from '@/services/objetos'
import { tipos } from '@/services/tipos'
import { nivelDificuldade } from '@/services/nivelDificuldade'

import Multiselect from 'vue-multiselect'
import Container from '@/components/shared/Container'
import LoadContent from '@/components/shared/LoadContent'
import newModal from '@/components/shared/NewModal'
import historico from '@/components/views/questoes/Historico'
import statusObjeto from '@/assets/enum/statusObjeto'
import MathQuestionEditor from '@/components/shared/MathQuestionEditor'

import { getCode } from '@/helpers/questionCode'

export default {
	name: 'createQuestao',
	components: {
		Container,
		historico,
		newModal,
		Multiselect,
		LoadContent,
		MathQuestionEditor
	},
	data () {
		return {
			questao: {
				codigo: '',
				enunciado: '',
				alternativas: [
					{ id: '', valor: '', correta: true, rota: this.$route.name },
					{ id: '', valor: '', correta: false }
				],
				feedbackPositivo: '',
				feedbackNegativo: '',
				tipoQuestao: '',
				curadoria: '',
				subCuradoria: '',
				eixo: '',
				tema: '',
				tipoObjeto: '',
				nivelDificuldade: '',
				status: statusObjeto.find((el) => el.status === 2)
			},
			curadorias: [],
			temas: [],
			tiposQuestao: [],
			tiposObjeto: [],
			niveisDificuldade: [],
			sending: false,
			notSend: false,
			historyId: undefined,
			isLoaded: true,
			objeto: {},
			statusList: statusObjeto.map((el) =>
				Object.assign(el, { $isDisabled: el.filterOnly })
			)
		}
	},
	computed: {
		pageTitle () {
			let pageTitle = ''
			switch (this.$route.name) {
			case 'questoesDetails':
				pageTitle = 'Visualizar questão'
				break

			case 'questoesCreate':
				pageTitle = 'Cadastrar questão'
				break

			case 'questoesEdit':
				pageTitle = 'Editar questão'
				break
			}

			return pageTitle
		},
		curadoriasList () {
			return this.curadorias.map((el, i) => {
				return { id: el.id, nome: el.nome, codigo: el.codigo, index: i }
			})
		},
		subCuradoriasList () {
			const curadoria = this.questao.curadoria || {}

			if (!curadoria.index && curadoria.index !== 0) {
				return []
			}

			const subCuradorias = this.curadorias[curadoria.index].subCuradorias
			return subCuradorias.map((el, i) => {
				return { id: el.id, nome: el.nome, codigo: el.codigo, index: i }
			})
		},
		eixosList () {
			const curadoria = this.questao.curadoria || {}
			const subCuradoria = this.questao.subCuradoria || {}

			if (!subCuradoria.index && subCuradoria.index !== 0) {
				return []
			}

			const eixos = this.curadorias[curadoria.index].subCuradorias[
				subCuradoria.index
			].subCuradorias
			return eixos.map((el, i) => {
				return { id: el.id, nome: el.nome, codigo: el.codigo, index: i }
			})
		}
	},
	created () {
		const reqs = [
			questoes.findTipos(),
			curadoria.findByActiveInTree(),
			tipos.find(),
			nivelDificuldade.find()
		]

		if (this.$route.params.id) {
			this.isLoaded = false
			reqs.push(questoes.findQuestionById(this.$route.params.id))
		}

		Promise.all(reqs).then((data) => {
			this.tiposQuestao = data[0].data
			this.curadorias = data[1].data
			this.tiposObjeto = data[2].data.filter((el) => el.possuiQuestao)
			this.niveisDificuldade = data[3].data

			const questionData = data[4]
			if (questionData) {
				this.loadQuestion(questionData.data)
			}
		})
	},
	mounted () {
		this.changeTab(0)
	},
	methods: {

		getInfoComponent (id, value, index) {
			// função de retorno do componente MathQuestionEditor.
			// Importante setar os id's de forma consistente no componente e no switch.
			switch (id) {
			case '1':
				this.questao.enunciado = value
				break

			case '2':
				this.questao.alternativas[index].valor = value
				break
			case '3':
				this.questao.feedbackPositivo = value
				break

			case '4':
				this.questao.feedbackNegativo = value
				break

			default:
				break
			}
		},
		getTextAlternatives (value) {
			const parsed = this.questao.alternativas[value].valor.replaceAll(
				'<p',
				'<p style="gap: 5px; display: flex; align-items: center;"'
			)
			this.alternativasMathJAX.splice(value, 1, parsed)
		},
		getCode,
		clearBonding () {
			this.questao.curadoria = null
			this.questao.subCuradoria = null
			this.questao.eixo = null
			this.questao.tema = null
			this.questao.tipoQuestao = null
			this.questao.tipoObjeto = null
			this.questao.nivelDificuldade = null

			this.temas = []
		},
		changeTab (index) {
			this.$el
				.querySelectorAll('.editor-alternatives-tabs-button')
				.forEach((tab) => {
					if (tab.dataset.tabIndex === index.toString()) {
						tab.classList.add('active')
					} else {
						tab.classList.remove('active')
					}
				})

			this.$el
				.querySelectorAll('.editor.editor-alternatives-tab-editor')
				.forEach((tab) => {
					if (tab.dataset.tabIndex === index.toString()) {
						tab.classList.remove('hidden')
					} else {
						tab.classList.add('hidden')
					}
				})
		},
		removeAlternative (index) {
			if (this.questao.alternativas.length > 2) {
				this.questao.alternativas.splice(index, 1)
				if (this.questao.alternativas.length <= index) {
					this.changeTab(index - 1)
				}
			} else {
				window.notificationEM.open(
					'',
					'Ao menos 2 alternativas precisam ser preenchidas',
					'error'
				)
			}
		},
		addAlternative () {
			this.questao.alternativas.push({
				enunciado: '',
				correta: false,
				rota: this.$route.name
			})
			this.changeTab(this.questao.alternativas.length - 1)
			// gambi pra acender a aba (quando a aba é alterada, ela ainda não existe e por isso não pode ser alterada)
			setTimeout(
				() => this.changeTab(this.questao.alternativas.length - 1),
				20
			)
		},
		selectAlternative (index) {
			// Múltiplas alternativas corretas
			// this.questao.alternativas[index].correta = !this.questao.alternativas[index].correta

			// Apenas uma alternativa correta
			let i = 0
			for (i in this.questao.alternativas) {
				this.questao.alternativas[i].correta = false
			}

			this.questao.alternativas[index].correta = true
		},
		async loadThemes (eixo, tipo) {
			// O eixo é obrigatório para a busca
			if (!eixo) return
			tipo = tipo || {}

			const req = await objetos.findByQuestionsEnabled(
				eixo.id,
				typeof tipo.id !== 'undefined' ? tipo.id : null
			)
			this.temas = req.data
		},
		clearSubs () {
			this.questao.subCuradoria = null
			this.questao.eixo = null
			this.questao.tema = null
			this.temas = []
		},
		clearEixos () {
			this.questao.eixo = null
			this.questao.tema = null
			this.temas = []
		},
		limparTema () {
			this.questao.tema = null
		},
		carregarTipo () {
			this.questao.tipoObjeto = {
				id: this.questao.tema.tipoId,
				tipoCodigo: this.questao.tema.tipoCodigo,
				nomeTipo: this.questao.tema.tipoNome
			}
		},
		validateQuestion () {
			const errors = []
			if (this.questao.tema === null || !this.questao.tema.id) {
				errors.push('É necessário informar um objeto para prosseguir')
			}

			if (this.questao.tipoQuestao === null || !this.questao.tipoQuestao.id) {
				errors.push('É necessário informar um tipo de questão para prosseguir')
			}

			if (this.questao.enunciado === '' || !this.questao.enunciado) {
				errors.push(
					'É necessário informar um texto de enunciado da questão para prosseguir'
				)
			}

			if (
				this.questao.feedbackPositivo === '' ||
        !this.questao.feedbackPositivo
			) {
				errors.push(
					'É necessário informar um texto de feedback positivo da questão para prosseguir'
				)
			}

			if (
				this.questao.feedbackNegativo === '' ||
        !this.questao.feedbackNegativo
			) {
				errors.push(
					'É necessário informar um texto de feedback negativo da questão para prosseguir'
				)
			}

			let i = 0
			let corrects = 0
			for (i in this.questao.alternativas) {
				const question = this.questao.alternativas[i]

				if (!question.valor) {
					errors.push(
						`É necessário informar o texto da alternativa ${
							parseInt(i) + 1
						} para prosseguir`
					)
				}

				if (question.correta) corrects++
			}

			if (corrects === 0) {
				errors.push('É necessário selecionar uma alternativa correta')
			}

			return errors.length ? errors : true
		},
		treatQuestion () {
			const dtInsert = new Date(this.questao.tema.dtInsert)
			const mes = `${dtInsert.getMonth() + 1}`
			const ano = `${dtInsert.getFullYear()}`.substring(2, 4)

			const params = {
				enunciado: this.questao.enunciado,
				alternativas: this.questao.alternativas,
				feedbackNegativo: this.questao.feedbackNegativo,
				feedbackPositivo: this.questao.feedbackPositivo,
				status: this.questao.status
					? this.questao.status.status.toString()
					: statusObjeto.find((el) => el.status === 2).id.toString(), // 2 => Pendente
				idAutor: this.questao.idAutor || this.$auth.user().id,
				idObjetoOrigem: this.questao.tema.id,
				nomeTema: this.questao.tema.titulo,
				temaCodigo: this.questao.tema.codigo,
				idTipoQuestao: this.questao.tipoQuestao.id,
				idNivelDificuldade: this.questao.nivelDificuldade
					? this.questao.nivelDificuldade.id
					: null,
				curadoriaCodigo: this.questao.curadoria.codigo,
				nomeCuradoria: this.questao.curadoria.nome,
				curadoriaId: this.questao.curadoria.id,
				subCuradoriaId: this.questao.subCuradoria.id,
				nomeSubCuradoria: this.questao.subCuradoria.nome,
				eixo: this.questao.eixo.nome,
				eixoId: this.questao.eixo.id,
				nomeEixo: this.questao.eixo.nome,
				tipoId: this.questao.tipoObjeto.id,
				tipoCodigo: this.questao.tipoObjeto.codigo,
				nomeTipo: this.questao.tipoObjeto.nome,
				anoMes: `${ano}${mes.padStart(2, '0')}`
			}

			return params
		},
		submitForm () {
			const errList = this.validateQuestion()

			if (errList !== true) {
				const msg = errList.join('<br />')
				window.notificationEM.open('', msg, 'warning')
				return
			}

			let req
			this.sending = true
			if (this.$route.params.id) {
				req = questoes.update(this.$route.params.id, this.treatQuestion())
			} else {
				req = questoes.create(this.treatQuestion())
			}

			req
				.then((res) => {
					window.notificationEM.open(
						'',
						'Questão salva com sucesso!',
						'success'
					)
					this.sending = false

					if (!this.$route.params.id) {
						// Limpa os dados da questão (exceto vínculos)
						this.questao.enunciado = ''
						this.questao.alternativas = [
							{ id: '', valor: '', correta: false },
							{ id: '', valor: '', correta: false },
							{ id: '', valor: '', correta: false },
							{ id: '', valor: '', correta: false }
						]
						this.questao.feedbackPositivo = ''
						this.questao.feedbackNegativo = ''

						window.scroll(0, 0)
					}
				})
				.catch((res) => {
					window.notificationEM.open(
						'',
						'Houve uma falha ao salvar a questão!',
						'error'
					)
					this.sending = false
				})
		},
		async loadQuestion (data) {
			const valores = data.valores.split('|~|')
			const corretas = data.corretas.split('|~|')
			const datas = data.datas.split('|~|')
			const alternativas = []
			for (var i = 0; i < corretas.length; i++) {
				alternativas.push({
					valor: valores[i],
					correta: corretas[i] === '1',
					dataCriacao: datas[i],
					rota: this.$route.name
				})
			}

			this.questao.id = data.id
			this.questao.enunciado = data.enunciado
			this.questao.alternativas = alternativas
			this.questao.feedbackPositivo = data.feedbackPositivo
			this.questao.feedbackNegativo = data.feedbackNegativo
			this.questao.curadoria = this.curadoriasList.find(
				(el) => el.id === data.curadoriaId
			)
			this.questao.subCuradoria = this.subCuradoriasList.find(
				(el) => el.id === data.subCuradoriaId
			)
			this.questao.eixo = this.eixosList.find((el) => el.id === data.eixoId)
			this.questao.tipoQuestao = this.tiposQuestao.find(
				(el) => el.id === data.idTipoQuestao
			)
			this.questao.nivelDificuldade = (this.niveisDificuldade || []).find(
				(el) => el.id === data.idNivelDificuldade
			)
			this.questao.dtInsert = data.dtInsert
			this.questao.dtUpdate = data.dtUpdate
			this.questao.codigo = data.codigo
			this.questao.historico = data.historico
			this.questao.status = this.statusList.find(
				(el) => el.nome.toUpperCase() === data.status
			) || { status: 2, nome: 'Pendente' }

			this.objeto = {
				temaCodigo: data.temaCodigo,
				anoMes: data.anoMes,
				curadoriaCodigo: data.curadoriaCodigo,
				tipoCodigo: data.tipoCodigo
			}

			await this.loadThemes(this.questao.eixo)
			this.questao.tema = this.temas.find(
				(el) => el.id === data.idObjetoOrigem
			)

			if (this.questao.tema) {
				this.questao.tipoObjeto = this.tiposObjeto.find(
					(el) => el.id === this.questao.tema.idTipo
				)
				if (!this.questao.tipoObjeto) {
					this.questao.tipoObjeto = this.tiposObjeto.find(
						(el) => el.id === this.questao.tema.tipoId
					)
				} else {
					window.notificationEM.open(
						'',
						'O tipo de objeto associado a essa questão não foi encontrado na base de dados.',
						'warning'
					)
				}
			} else {
				window.notificationEM.open(
					'',
					'O objeto associado a essa questão não foi encontrado na base de dados.',
					'warning'
				)
			}

			this.isLoaded = true

			setTimeout(() => this.changeTab(0), 40)
		}
	}
}
</script>

<style lang="scss" scoped>
form.readOnly {
  .multiselect,
  .quillWrapper,
  .btn.editor-alternatives-tabs-add,
  .btn.editor-alternatives-tab-remove,
  .editor-alternatives-select-option {
    pointer-events: none;

    & * {
      pointer-events: inherit;
    }
  }
}

.orientacoes {
  font-family: $font-family-alternative;
  padding: 20px;
  border-radius: $border-radius;
  background-color: #4f5c6b;
  font-size: $font-size;
  color: #f9fdff;

  b {
    font-weight: bold;
  }
  p {
    font-weight: 400;
  }
}

.vinculo {
  padding: 20px;
  margin-top: 20px;
  border-radius: $border-radius;
  background-color: #00243e;
  font-size: $font-size;
  color: #fff;

  b {
    display: inline-block;
    margin-bottom: 10px;
  }

  .bonding-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-areas:
      "curadoria subcuradoria eixo eixo"
      "tipoObjeto tema tema tema"
      "nivel tipo tipo limpar";
    gap: 10px;

    .select {
      max-width: 100%;
      height: 45px;
      padding: 0 5px;
      border-radius: $border-radius;
      background-color: #ffffff;
    }

    .select.curadoria {
      grid-area: curadoria;
    }

    .select.subcuradoria {
      grid-area: subcuradoria;
    }

    .select.eixo {
      grid-area: eixo;
    }

    .select.tema {
      grid-area: tema;
    }

    .select.tipo {
      grid-area: tipo;
    }

    .select.nivel {
      grid-area: nivel;
    }

    .actions {
      grid-area: limpar;
      text-align: right;

      .btn.limpar {
        display: inline-block;
        width: 100%;
        padding: 9.5px 35px;
        border-radius: $border-radius;
        background-color: #dc6363;
        color: #fff;
        text-transform: uppercase;
        text-decoration: none;
        text-align: center;
      }
    }
  }
}

.editor-container {
  margin-top: 20px;
  border-radius: 10px;
  background-color: #fff;

  .editor-container-header {
    display: flex;
    align-items: center;
    padding: 20px;
    border-radius: 10px 10px 0 0;
    background-color: #4f5c6b;
    font-size: 20px;
    color: #fff;
    position: relative;

    .codigo {
      display: inline-block;
      padding: 6px 14px;
      margin-left: 10px;
      border-radius: 20px;
      background-color: #3b4550;
      color: #f9fdff;
      font-size: 12px;

      &.error {
        background-color: #f00a;
      }
    }

    .historico {
      position: absolute;
      right: 20px;

      button {
        background-color: $main-color;
        font-weight: $font-weight-buttons;
        border: none;
        cursor: pointer;
        color: white;
        padding: 10px;
        border-radius: 4px;
        &:hover {
          background-color: #0f1924;
        }
        &:disabled {
          background-color: #9e9e9e;
          cursor: default;
        }
      }
    }
  }

  .editor-container-body {
    padding: 24px 20px 34px 26px;

    .editor-question-data {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      margin-bottom: 15px;
      color: #707070;

      b {
        font-weight: bold;
      }

      .select {
        min-height: 48px;
        border: 1px solid #ccc;
        border-radius: $border-radius;
      }
    }

    .editor {
      .editor-header {
        padding: 15px 20px;
        background-color: #f3f3f3;
        color: #707070;
        font-family: $font-family-alternative;
        font-size: 18px;
        font-weight: bold;
      }
    }

    .mjx-chtml .MJXc-display {
      display: inline !important;
    }

    .editor-enunciado {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
      background-color: #f3f3f3;
      color: #707070;
      font-family: $font-family-alternative;
      font-size: 18px;
      font-weight: bold;
    }

    .mathml-vue2editor {
      position: relative;

      .visualizar-mathml {
        position: absolute;
        right: 5px;
        top: 10px;
        border: none;
        outline: none;
        background: none;
        cursor: pointer;
        z-index: 1;

        .icone-mathml {
          cursor: pointer;
          color: #444444;
        }

        .icone-mathml:hover {
          color: #0066cc;
        }
      }
    }

    .visualizar {
      border: none;
      outline: none;
      background-color: #018033;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      height: 38px;
      width: 95px;
      color: #fff;
      font-size: 15px;
      font-weight: lighter;
      transition: opacity 0.1s;
      padding: 0 10px 0 10px;
      cursor: pointer;
    }

    .texto-visualizar {
      font-family: $font-family-alternative;
    }

    .visualizar:hover {
      opacity: 0.9;
    }

    .visualizar-excluir {
      border: none;
      outline: none;
      background-color: #c93f3f;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      height: 38px;
      color: #fff;
      font-size: 15px;
      font-weight: lighter;
      transition: opacity 0.1s;
      padding: 0 10px 0 10px;
      cursor: pointer;
    }

    .visualizar-excluir:hover {
      opacity: 0.9;
    }

    .button-container {
      display: flex;
      position: relative;
      gap: 10px;
    }

    .textarea-container {
      position: absolute;
      border: 1px solid #f3f3f3;
      border-radius: 5px;
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
      background-color: #fff;
      padding: 15px;
      left: -320px;
      transition: display 0.3s;
      z-index: 2;
      display: flex;
      align-items: flex-end;
      flex-direction: column;
      gap: 10px;

      .textearea-box {
        border: 1px solid #f3f3f3;
        padding: 5px;
      }
    }

    .mathjax-container {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      border: solid 1px #f3f3f3;
    }

    .mathjaxview {
      padding: 8px;
      height: 50%;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 5px;
    }
    .mathjaxview p {
      width: 100% !important;
      display: flex !important;
      justify-content: flex-start !important;
      align-items: center !important;
      gap: 5px !important;
      background: crimson !important;
    }

    .editor-alternatives {
      position: relative;

      .editor-alternatives-tabs-menu {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        min-height: 56px;
        margin: 10px 70px 0 0;

        .editor-alternatives-tabs-button {
          display: inline-block;
          padding: 10px 20px;
          margin: 10px 10px 0 0;
          border-radius: $border-radius;
          background-color: #f3f3f3;
          color: #707070;
          font-size: 15px;
          font-weight: bold;
          text-transform: uppercase;
          text-decoration: none;
          text-align: center;

          &:hover,
          &.active {
            background-color: #15adbc;
            color: #ffffff;
          }
        }

        .btn.editor-alternatives-tabs-add {
          position: absolute;
          top: 10px;
          right: 10px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 46px;
          height: 46px;
          border-radius: 100%;
          background-color: #15adbc;
          color: #fff;
          text-decoration: none;
          transition: background-color 0.127s;

          &:hover {
            background-color: #1397a3;
          }
        }
      }

      .editor.editor-alternatives-tab-editor {
        position: relative;
        margin-top: 20px;

        &.hidden {
          display: none;
        }

        .btn.editor-alternatives-tab-remove {
          position: absolute;
          right: 10px;
          top: 10px;
          display: inline-block;
          padding: 6px 15px;
          border-radius: $border-radius;
          background-color: #d54141;
          color: #fff;
          font-size: 15px;
          text-decoration: none;
          transition: background-color 0.127s;

          &:hover {
            background-color: #c93f3f;
          }

          .fas {
            margin-right: 6px;
          }
        }
      }

      .editor-alternatives-select {
        padding: 20px;
        margin-top: 25px;
        border-radius: 10px;
        background-color: #00243e;
        color: #fff;

        .editor-alternatives-select-option {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 30px;
          height: 30px;
          margin-right: 5px;
          border-radius: 50%;
          background-color: #f3f3f3;
          color: #00243e;
          font-size: 14px;
          font-weight: bold;
          text-decoration: none;

          &:first-child {
            margin-left: 15px;
          }

          &:hover,
          &.active {
            background-color: #eff536;
          }
        }
      }
    }

    .editor-positive-feedback,
    .editor-negative-feedback {
      margin-top: 20px;
    }
  }

  .box-warning {
    margin: 0 25px 25px 25px;
  }

  .editor-actions {
    padding-bottom: 30px;
    text-align: center;

    a.btn {
      position: relative;
      display: inline-grid;
      place-items: center;
      width: 215px;
      height: 56px;
      border-radius: $border-radius;
      text-transform: uppercase;
      text-decoration: none;
      font-family: $font-family-alternative;
      letter-spacing: 0px;
      transition: background-color 0.127s, border 0.127s;

      &:not(:last-child) {
        margin-right: 10px;
      }

      &.editor-submit {
        background-color: #3367d6;
        color: #fff;

        &:hover {
          background-color: #2b56b3;
        }

        &.sending {
          background-color: #555;
          cursor: not-allowed;
          pointer-events: none;
        }

        span.loading {
          display: inline-block;
          width: 30px;
          height: 30px;
          border: none;
          border-left: 3px solid #fff;
          border-radius: 50%;
        }
      }

      &.voltar-button {
        position: relative;
        border: 1px solid #555;
        color: #555;

        &:hover {
          background-color: #eee;
          border-color: transparent;
        }

        span {
          margin-left: 10px;
          .fas {
            position: absolute;
            top: 37.5%;
            left: 60px;
          }
        }
      }
    }
  }
}

#historico-modal {
  color: black;
  .header {
    width: 100%;
    display: inline-flex;
    color: $main-color;
    font-weight: $font-weight-default-bolder;
    font-size: $font-size-large;
    .close {
      margin-left: auto;
    }
  }
}

@media all and (max-width: 900px) {
  .editor-container
    .editor-container-body
    .editor-alternatives
    .editor-alternatives-tabs-menu {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>

<style lang="scss">
// Multiselect
.multiselect.select:not(.multiselect--active) {
  overflow: hidden;
}

// Editor
.quillWrapper {
  background-color: #fff;
  color: #000;

  .ql-toolbar.ql-snow,
  .ql-container.ql-snow {
    border: 1px solid #f3f3f3;
    position: relative;
  }

  .ql-editor img {
    max-width: 100% !important;
  }

  strong {
    font-weight: bold;
  }

  em {
    font-style: italic;
  }

  u {
    text-decoration: underline;
  }
}
</style>
